import { render } from "./TypeYesNoButton.vue?vue&type=template&id=44c5b51a&ts=true"
import script from "./TypeYesNoButton.vue?vue&type=script&lang=ts"
export * from "./TypeYesNoButton.vue?vue&type=script&lang=ts"

import "./TypeYesNoButton.vue?vue&type=style&index=0&id=44c5b51a&lang=css"

import exportComponent from "/home/hugo/Proyectos/TierraMedia2.0/edoras/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__